export default import.meta.ROLLDOWN_FILE_URL_U4sspHr$fzLvD1k5cV0yzw